import React, { useEffect } from "react";
import { Formik, Form, FieldArray, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import FieldArea from "../../../CustomComponents/FieldText";
import ReactSelect from "react-select";
import axiosInstance from "../../../../redux/api";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { titlevalidation } from "../../../Common/commonvalidation";

const options = [
  { value: "1", label: "Hourly" },
  { value: "2", label: "Daily" },
  { value: "3", label: "Weekly" },
  { value: "4", label: "Monthly" },
  { value: "5", label: "Quarterly" },
  { value: "6", label: "Yearly" },
];

const bxpDatatomap = [
  { title: "Price", name: "price", placeholder: "Enter total cost" },
  {
    title: "Payment terms",
    name: "payment_type",
    placeholder: "Payment terms",
  },
  { title: "Milestones", name: "milestones", placeholder: "Milestones" },
  {
    title: "Additional Notes / Terms",
    name: "terms",
    placeholder: "Type here",
  },
];

const PricingTerms = ({
  bxpData,
  setbxpData,
  setFormData,
  setActiveTab,
  setModalOpen,
}) => {
  const initialValues = {
    price: bxpData?.price || "",
    payment_type: bxpData?.payment_type || "",
    terms: bxpData?.terms || "",
    milestones: bxpData?.milestones || [
      {
        title: "",
        duration: "",
        amount: "",
      },
    ],
  };

  const validationSchema = Yup.object().shape({
    price: Yup.string().required("Price is required"),
    payment_type: Yup.string().required("Payment terms are required"),
    terms: Yup.string(),
    milestones: Yup.array().of(
      Yup.object().shape({
        title: titlevalidation,
        duration: Yup.string().required("Duration is required"),
        amount: Yup.string().required("Amount is required"),
      }),
    ),
  });

  const handleSubmit = async (values) => {
    try {
      const updatedBxpData = {
        ...bxpData,
        price: values.price,
        payment_type: values.payment_type,
        terms: values.terms,
        milestones: values.milestones,
      };
      setbxpData(updatedBxpData);

      hitapi(updatedBxpData);
    } catch (error) {
      console.error("Error submitting BXP:", error);
    }
  };
  const hitapi = (values) => {
    axiosInstance
      .post("bxp/create", values)
      .then((response) => {
        if (response.data.status) {
          // navigate(`/account/update-project/${response?.data?.response.id}`)
        }
        urtoast(response?.data?.response.message, 2);
      })
      .catch((error) => {
        urtoast(error.message, 2);
      });
  };

  const handleCategoryChange = (selectedOption, formik, index) => {
    const newMilestones = [...formik.values.milestones];
    newMilestones[index].duration = selectedOption.value;
    formik.setFieldValue("milestones", newMilestones);
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                if (prop.name == "payment_type") {
                  return (
                    <div key={key} className ="form-group">
                      <h6 className ="work-title">{prop.title}</h6>
                      <div className ="label-check">
                        <label className ="checkbox-container">
                          <Field type="radio" name={prop.name} value="1" />
                          <span className ="checkmark">
                            One time (Full Payment)
                          </span>
                        </label>
                        <label className ="checkbox-container">
                          <Field type="radio" name={prop.name} value="2" />
                          <span className ="checkmark">By Milestones</span>
                        </label>
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className ="error"
                        />
                      </div>
                    </div>
                  );
                }
                if (prop.name == "milestones") {
                  return (
                    <FieldArray name="milestones" key={key}>
                      {({ insert, remove, push }) => (
                        <div>
                          <h6 className ="work-title">{prop.title}</h6>
                          {formik.values.milestones.length > 0 &&
                            formik.values.milestones.map((milestone, index) => (
                              <div className ="milestone" key={index}>
                                <Field
                                  name={`milestones.${index}.title`}
                                  placeholder="Enter milestone name"
                                />
                                <ErrorMessage
                                  name={`milestones.${index}.title`}
                                  component="div"
                                  className ="error"
                                />
                                <ReactSelect
                                  options={options}
                                  placeholder="Select Duration"
                                  value={options.find(
                                    (option) =>
                                      option.value === milestone.duration,
                                  )}
                                  onChange={(selectedOption) =>
                                    handleCategoryChange(
                                      selectedOption,
                                      formik,
                                      index,
                                    )
                                  }
                                />
                                <ErrorMessage
                                  name={`milestones.${index}.duration`}
                                  component="div"
                                  className ="error"
                                />
                                <Field
                                  name={`milestones.${index}.amount`}
                                  placeholder="Enter amount in SAR"
                                />
                                <ErrorMessage
                                  name={`milestones.${index}.amount`}
                                  component="div"
                                  className ="error"
                                />
                                <button
                                  type="button"
                                  onClick={() => remove(index)}
                                >
                                  Remove
                                </button>
                              </div>
                            ))}
                          <button
                            type="button"
                            onClick={() =>
                              push({ title: "", duration: "", amount: "" })
                            }
                          >
                            Add more milestones
                          </button>
                        </div>
                      )}
                    </FieldArray>
                  );
                }
                if (prop.name == "terms") {
                  return (
                    <FieldArea
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                }
                return (
                  <FieldInput
                    title={prop.title}
                    name={prop.name}
                    placeholder={prop.placeholder}
                    key={key}
                  />
                );
              })}

              <div className ="button-container">
                <button
                  className ="prev-button w-100"
                  onClick={() => setActiveTab("WorkSamples")}
                >
                  Back
                </button>
                <button className ="next-button w-100" type="submit">
                  Add BXP
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PricingTerms;
